import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FB_PIXEL_ID = '895841806711323';
export const MetaPixel = () => {
  useEffect(() => {
    // Skip if already initialized
    if (window.fbq) return;
    // Initialize fbq function
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      // Initialize pixel after script loads
      window.fbq('init', FB_PIXEL_ID);
      window.fbq('track', 'PageView');
    };
    document.head.appendChild(script);
    // Also call init immediately in case script is cached
    setTimeout(() => {
      if (window.fbq) {
        window.fbq('init', FB_PIXEL_ID);
        window.fbq('track', 'PageView');
      }
    }, 100);
  }, []);
  // Noscript fallback for users without JavaScript
  return <noscript data-id="element-125">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-126" />
    </noscript>;
};